import React from "react";
import SectionOne from "./components/SectionOne/index";
import Main from "./components/Main/index";
import SectionTwo from "./components/SectionTwo/index";
import SectionContato from "./components/SectionContato/index"
import Footer from './components/Footer/index'
function App() {

  return (
     <>
      <Main />
      <SectionOne />
      <SectionTwo />
      <Footer />
      <SectionContato/>
     </> 
  )
}

export default App;
